export interface MasterItem {
  id: string;
  code: string;
  name: string;
  category: string;
  specs: string;
  defaultUomId: string;
  uomCode: string;
  defaultPrice: number;
}

export const MASTER_ITEMS: MasterItem[] = [
  {
    id: 'itm-001',
    code: 'ITM-001',
    name: 'Corrugated Carton Box 40x30x20',
    category: 'Packaging',
    specs: 'Double wall, kraft paper 275gsm',
    defaultUomId: 'uom-001',
    uomCode: 'PCS',
    defaultPrice: 8500,
  },
  {
    id: 'itm-002',
    code: 'ITM-002',
    name: 'Bubble Wrap 1.25m x 50m',
    category: 'Packaging',
    specs: 'Clear, 10mm bubble diameter, heavy duty',
    defaultUomId: 'uom-002',
    uomCode: 'ROLL',
    defaultPrice: 165000,
  },
  {
    id: 'itm-003',
    code: 'ITM-003',
    name: 'Stretch Film 500mm x 250m',
    category: 'Packaging',
    specs: '17 micron, cast film hand stretch',
    defaultUomId: 'uom-002',
    uomCode: 'ROLL',
    defaultPrice: 92000,
  },
  {
    id: 'itm-004',
    code: 'ITM-004',
    name: 'Industrial Opp Tape 2 inch Clear',
    category: 'Consumables',
    specs: '48mm x 90m, 45 micron acrylic adhesive',
    defaultUomId: 'uom-001',
    uomCode: 'PCS',
    defaultPrice: 12500,
  },
  {
    id: 'itm-005',
    code: 'ITM-005',
    name: 'Standard Wooden Pallet 1200x1000mm',
    category: 'Warehouse Equipment',
    specs: 'ISPM 15 heat treated, 4-way entry, capacity 1000kg',
    defaultUomId: 'uom-001',
    uomCode: 'PCS',
    defaultPrice: 225000,
  },
  {
    id: 'itm-006',
    code: 'ITM-006',
    name: 'Heavy Duty Thermal Transfer Ribbon',
    category: 'Consumables',
    specs: 'Wax/Resin 110mm x 300m for barcode printers',
    defaultUomId: 'uom-002',
    uomCode: 'ROLL',
    defaultPrice: 110000,
  },
  {
    id: 'itm-007',
    code: 'ITM-007',
    name: 'Kain Katun Rayon',
    category: 'Raw Materials',
    specs: 'Lebar 150cm, 100% Rayon Grade A',
    defaultUomId: 'uom-003',
    uomCode: 'METER',
    defaultPrice: 20000,
  },
  {
    id: 'itm-008',
    code: 'ITM-008',
    name: 'Kancing Kemeja 4 Lubang',
    category: 'Accessories',
    specs: 'Diameter 11mm, Pearl White Polyester',
    defaultUomId: 'uom-001',
    uomCode: 'PCS',
    defaultPrice: 500,
  },
  {
    id: 'itm-009',
    code: 'ITM-009',
    name: 'Benang Jahit Spun Polyester 40/2',
    category: 'Accessories',
    specs: 'Panjang 5000 yard, warna Hitam/Putih, high tensile strength',
    defaultUomId: 'uom-001',
    uomCode: 'PCS',
    defaultPrice: 14500,
  },
  {
    id: 'itm-010',
    code: 'ITM-010',
    name: 'Resleting / Zipper YKK Metal 5 inch',
    category: 'Accessories',
    specs: 'Gigi kuningan antik, closed-end, slider semi-lock',
    defaultUomId: 'uom-001',
    uomCode: 'PCS',
    defaultPrice: 4200,
  },
  {
    id: 'itm-011',
    code: 'ITM-011',
    name: 'Kain Denim Stretch 12oz Indigo',
    category: 'Raw Materials',
    specs: 'Komposisi 98% Cotton 2% Spandex, lebar 148cm',
    defaultUomId: 'uom-003',
    uomCode: 'METER',
    defaultPrice: 45000,
  },
  {
    id: 'itm-012',
    code: 'ITM-012',
    name: 'Kain Spunlace Non-Woven Interlining',
    category: 'Raw Materials',
    specs: 'Ketebalan 50gsm, fusible microdot adhesive',
    defaultUomId: 'uom-003',
    uomCode: 'METER',
    defaultPrice: 18000,
  },
  {
    id: 'itm-013',
    code: 'ITM-013',
    name: 'Plastik Polybag Klip 30x40cm',
    category: 'Packaging',
    specs: 'Ketebalan 0.05mm, zipper klip kedap udara, bening transparan',
    defaultUomId: 'uom-001',
    uomCode: 'PCS',
    defaultPrice: 650,
  },
  {
    id: 'itm-014',
    code: 'ITM-014',
    name: 'Label Woven Satin Brand PT XYZ',
    category: 'Accessories',
    specs: 'Ukuran 25x55mm, woven damask kualitas ekspor, laser cut edge',
    defaultUomId: 'uom-001',
    uomCode: 'PCS',
    defaultPrice: 350,
  },
  {
    id: 'itm-015',
    code: 'ITM-015',
    name: 'Silica Gel Desiccant 2gr White',
    category: 'Consumables',
    specs: 'Kemasan kertas breathable sachet 2 gram, non-toxic',
    defaultUomId: 'uom-004',
    uomCode: 'PACK',
    defaultPrice: 25000,
  },
  {
    id: 'itm-016',
    code: 'ITM-016',
    name: 'Jarum Mesin Jahit Groz-Beckert DPx5 #14',
    category: 'Consumables',
    specs: 'Original Germany, ujung R/RG untuk bahan woven sedang, isi 10 batang',
    defaultUomId: 'uom-005',
    uomCode: 'BOX',
    defaultPrice: 85000,
  },
  {
    id: 'itm-017',
    code: 'ITM-017',
    name: 'Tali Webbing Katun 2.5cm Tebal',
    category: 'Raw Materials',
    specs: 'Lebar 25mm, anyaman herringbone tebal 1.8mm, roll 50 yard',
    defaultUomId: 'uom-002',
    uomCode: 'ROLL',
    defaultPrice: 75000,
  },
  {
    id: 'itm-018',
    code: 'ITM-018',
    name: 'Hand Pallet Truck 3 Ton Heavy Duty',
    category: 'Warehouse Equipment',
    specs: 'Kapasitas angkut 3000kg, fork 1220x685mm, roda polyurethane',
    defaultUomId: 'uom-001',
    uomCode: 'UNIT',
    defaultPrice: 3850000,
  },
  {
    id: 'itm-019',
    code: 'ITM-019',
    name: 'Sarung Tangan Kerja Katun Rajut Bintik',
    category: 'Consumables',
    specs: 'Benang katun 7 gauge, lapisan bintik PVC anti-slip di telapak tangan',
    defaultUomId: 'uom-001',
    uomCode: 'PASANG',
    defaultPrice: 6500,
  },
  {
    id: 'itm-020',
    code: 'ITM-020',
    name: 'Stiker Barcode Thermal 100x50mm',
    category: 'Packaging',
    specs: 'Direct thermal label roll, isi 1000 pcs per roll, core 1 inch',
    defaultUomId: 'uom-002',
    uomCode: 'ROLL',
    defaultPrice: 42000,
  },
];
